.customValueWithDivider {
  display: flex;
  column-gap: inherit;
  align-items: center;
}

.divider {
  height: 18px;
  opacity: 1;
}
